<template>
  <div class="p-4 max-w-xl mx-auto" v-if="!isLoading">
    <div
      @click="$router.back()"
      class="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer shadow-md transition"
    >
      <BackSvg />
    </div>
    <div class="pb-6 flex flex-col justify-center items-center">
      <h2 class="text-lg text-zinc-700 text-center font-semibold">
        Account Profile
      </h2>
    </div>
    <div>
      <div class="flex flex-col gap-3 items-center justify-center">
        <img
          class="w-28 h-28 object-cover rounded-full"
          :src="profileImageUrl"
          alt="Profile"
        />
        <span>
          <h3 class="text-lg text-center font-semibold text-gray-800">
            {{ $store.state.userLogged }}
          </h3>
          <h2 class="text-center text-zinc-600">
            {{ $store.state.userControlNumber }}
          </h2>
        </span>
      </div>
      <div class="my-10 space-y-3 mx-3">
        <div>
          <h4 class="text-xs text-zinc-600">Email Address</h4>
          <h2>{{ $store.state.userEmail }}</h2>
        </div>
        <div>
          <h4 class="text-xs text-zinc-600">Contact Number</h4>
          <h2>{{ $store.state.userContact }}</h2>
        </div>
        <div>
          <h4 class="text-xs text-zinc-600">Member Since</h4>
          <h2>{{ dateFormat($store.state.userMemberSince) }}</h2>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="flex items-center justify-center h-48" v-if="isLoading">
      <svg
        class="w-10 h-10 animate-spin text-orange-600"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
    </div>
  </div>
</template>
<script>
import { ref, computed, onMounted, inject } from "vue";
import BackSvg from "@/components/svgs/BackSvg.vue";
export default {
  name: "TransactionList",
  components: {
    BackSvg,
  },
  setup() {
    const isLoading = ref(false);
    const moment = inject("$moment");

    const profileImageUrl = computed(() => {
      return localStorage.getItem("patientProfile");
    });

    const dateFormat = (val) => {
      return moment(val).format("LL");
    };

    return {
      dateFormat,
      profileImageUrl,
      isLoading,
    };
  },
};
</script>
